var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialistCaseViewer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 832,
    viewBox: "0 0 1280 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_5629)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 680,
    width: 1280,
    height: 152,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_935_5629)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_935_5629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419 181.466C419 175.134 424.134 170 430.466 170H1141.39C1147.72 170 1152.85 175.134 1152.85 181.466V647.004H419V181.466Z",
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 191.213,
    width: 693.719,
    height: 455.791,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 223.892,
    width: 693.719,
    height: 455.791,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 256.572,
    width: 693.719,
    height: 455.791,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 245.678,
    width: 693.719,
    height: 401.325,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 272.625,
    width: 83.7049,
    height: 469.55,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.969,
    y: 286.384,
    width: 448.911,
    height: 76.2518,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 245.678,
    width: 693.719,
    height: 25.7995,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.64,
    y: 272.625,
    width: 130.144,
    height: 373.806,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.969,
    y: 377.428,
    width: 448.911,
    height: 133.584,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.969,
    y: 525.803,
    width: 448.911,
    height: 168.557,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.062,
    y: 191.213,
    width: 693.719,
    height: 29.8127,
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.156,
    y: 300.717,
    width: 49.3053,
    height: 10.3197,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 470.421,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 481.314,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.688,
    y: 470.421,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.688,
    y: 481.314,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.648,
    y: 470.421,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.648,
    y: 481.314,
    width: 51.5986,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.141,
    y: 470.421,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.141,
    y: 481.314,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.18,
    y: 470.421,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.18,
    y: 481.314,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.094,
    y: 470.421,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.094,
    y: 481.314,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 440.034,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 450.927,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.688,
    y: 440.034,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.688,
    y: 450.927,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.648,
    y: 440.034,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.648,
    y: 450.927,
    width: 51.5986,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.141,
    y: 440.034,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.141,
    y: 450.927,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.18,
    y: 440.034,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.18,
    y: 450.927,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.094,
    y: 440.034,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.094,
    y: 450.927,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.156,
    y: 327.663,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.156,
    y: 338.557,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.117,
    y: 327.663,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.117,
    y: 338.557,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.07,
    y: 327.663,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.07,
    y: 338.557,
    width: 51.5986,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.562,
    y: 327.663,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.562,
    y: 338.557,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.609,
    y: 327.663,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.609,
    y: 338.557,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.523,
    y: 327.663,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.523,
    y: 338.557,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.547,
    y: 237.079,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.547,
    y: 247.972,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.375 253.703L517.036 237.08",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.844,
    y: 237.079,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.844,
    y: 247.972,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.672 253.703L591.333 237.08",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.141,
    y: 237.079,
    width: 33.2524,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.141,
    y: 247.972,
    width: 51.5986,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.547 253.703L666.208 237.08",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.016,
    y: 237.079,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.016,
    y: 247.972,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.844 253.703L740.505 237.08",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.312,
    y: 237.079,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.312,
    y: 247.972,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.141 253.703L814.801 237.08",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 826.609,
    y: 237.079,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 826.609,
    y: 247.972,
    width: 51.0252,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.438 253.703L889.098 237.08",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.906,
    y: 237.079,
    width: 32.6791,
    height: 5.73317,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.906,
    y: 247.972,
    width: 151.93,
    height: 5.73322,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.586,
    y: 394.742,
    width: 84.2776,
    height: 10.3197,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 570.809,
    width: 45.8654,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.586,
    y: 570.809,
    width: 45.8654,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.312,
    y: 570.809,
    width: 45.8654,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.031,
    y: 570.809,
    width: 45.8654,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.75,
    y: 570.809,
    width: 45.8654,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.156,
    y: 541.512,
    width: 77.3978,
    height: 10.3197,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 591.391,
    width: 57.3317,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.586,
    y: 591.391,
    width: 57.3317,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.312,
    y: 591.391,
    width: 57.3317,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.031,
    y: 591.391,
    width: 57.3317,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.75,
    y: 591.391,
    width: 57.3317,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 617.764,
    width: 52.1719,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.586,
    y: 617.764,
    width: 52.1719,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.312,
    y: 617.764,
    width: 52.1719,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.031,
    y: 617.764,
    width: 52.1719,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.75,
    y: 617.764,
    width: 52.1719,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 644.137,
    width: 59.625,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.586,
    y: 644.137,
    width: 59.625,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.312,
    y: 644.137,
    width: 59.625,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.031,
    y: 644.137,
    width: 59.625,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.75,
    y: 644.137,
    width: 59.625,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 604.578,
    width: 61.345,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.586,
    y: 604.578,
    width: 61.345,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.312,
    y: 604.578,
    width: 61.345,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.031,
    y: 604.578,
    width: 61.345,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.75,
    y: 604.578,
    width: 61.345,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.734,
    y: 630.95,
    width: 64.2115,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.586,
    y: 630.95,
    width: 64.2115,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.312,
    y: 630.95,
    width: 64.2115,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.031,
    y: 630.95,
    width: 64.2115,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.75,
    y: 630.95,
    width: 64.2115,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.586,
    y: 409.648,
    width: 41.8522,
    height: 6.87981,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.496,
    cy: 406.954,
    r: 16.3395,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.734 585.085H974.552",
    stroke: "#E7E9EE",
    strokeWidth: 0.573322
  })), /*#__PURE__*/React.createElement("path", {
    d: "M765 694H808V734.53C808 740.865 802.865 746 796.53 746H776.47C770.135 746 765 740.865 765 734.53V694Z",
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 742.47C623 736.135 628.135 731 634.47 731H936.53C942.865 731 948 736.135 948 742.47V762H623V742.47Z",
    fill: "#221D30"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_935_5629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419 181.469C419 175.135 424.135 170 430.469 170H1141.53C1147.87 170 1153 175.135 1153 181.469V647.1H419V181.469Z",
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.07,
    y: 191.217,
    width: 693.859,
    height: 455.883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.07,
    y: 223.903,
    width: 693.859,
    height: 455.883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.07,
    y: 256.589,
    width: 693.859,
    height: 455.883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.07,
    y: 245.694,
    width: 693.859,
    height: 401.406,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.07,
    y: 272.645,
    width: 83.7219,
    height: 469.645,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 286.408,
    width: 449.002,
    height: 76.2672,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.07,
    y: 245.694,
    width: 693.859,
    height: 25.8047,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.75,
    y: 272.645,
    width: 130.17,
    height: 373.881,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 377.47,
    width: 449.002,
    height: 133.611,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 525.875,
    width: 449.002,
    height: 168.591,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439,
    y: 179,
    width: 694,
    height: 42,
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.188,
    y: 300.744,
    width: 49.3156,
    height: 10.3219,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 470.481,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 481.377,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.734,
    y: 470.481,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.734,
    y: 481.377,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.695,
    y: 470.481,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.695,
    y: 481.377,
    width: 51.6094,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.227,
    y: 470.481,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.227,
    y: 481.377,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.242,
    y: 470.481,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.242,
    y: 481.377,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.203,
    y: 470.481,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.203,
    y: 481.377,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 440.089,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 450.984,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.734,
    y: 440.089,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.734,
    y: 450.984,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.695,
    y: 440.089,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.695,
    y: 450.984,
    width: 51.6094,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.227,
    y: 440.089,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850.227,
    y: 450.984,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.242,
    y: 440.089,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.242,
    y: 450.984,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.203,
    y: 440.089,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 924.203,
    y: 450.984,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.188,
    y: 327.695,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.188,
    y: 338.591,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.148,
    y: 327.695,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.148,
    y: 338.591,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.133,
    y: 327.695,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.133,
    y: 338.591,
    width: 51.6094,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.656,
    y: 327.695,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.656,
    y: 338.591,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.68,
    y: 327.695,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.68,
    y: 338.591,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.625,
    y: 327.695,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.625,
    y: 338.591,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.555,
    y: 237.092,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.555,
    y: 247.987,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.398 253.72L517.059 237.094",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.867,
    y: 237.092,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.867,
    y: 247.987,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.711 253.72L591.372 237.094",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.18,
    y: 237.092,
    width: 33.2594,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.18,
    y: 247.987,
    width: 51.6094,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.594 253.72L666.254 237.094",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.062,
    y: 237.092,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.062,
    y: 247.987,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.914 253.72L740.575 237.094",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.383,
    y: 237.092,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752.383,
    y: 247.987,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.227 253.72L814.887 237.094",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("rect", {
    x: 826.695,
    y: 237.092,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 826.695,
    y: 247.987,
    width: 51.0359,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.539 253.72L889.2 237.094",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("rect", {
    x: 901.008,
    y: 237.092,
    width: 32.6859,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 901.008,
    y: 247.987,
    width: 151.961,
    height: 5.73438,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.609,
    y: 394.787,
    width: 84.2953,
    height: 10.3219,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 570.89,
    width: 45.875,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.625,
    y: 570.89,
    width: 45.875,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.375,
    y: 570.89,
    width: 45.875,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.117,
    y: 570.89,
    width: 45.875,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.852,
    y: 570.89,
    width: 45.875,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.188,
    y: 541.588,
    width: 77.4141,
    height: 10.3219,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 591.477,
    width: 57.3438,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.625,
    y: 591.477,
    width: 57.3438,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.375,
    y: 591.477,
    width: 57.3438,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.117,
    y: 591.477,
    width: 57.3438,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.852,
    y: 591.477,
    width: 57.3438,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 617.855,
    width: 52.1828,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.625,
    y: 617.855,
    width: 52.1828,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.375,
    y: 617.855,
    width: 52.1828,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.117,
    y: 617.855,
    width: 52.1828,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.852,
    y: 617.855,
    width: 52.1828,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 644.233,
    width: 59.6375,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.625,
    y: 644.233,
    width: 59.6375,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.375,
    y: 644.233,
    width: 59.6375,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.117,
    y: 644.233,
    width: 59.6375,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.852,
    y: 644.233,
    width: 59.6375,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 604.666,
    width: 61.3578,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.625,
    y: 604.666,
    width: 61.3578,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.375,
    y: 604.666,
    width: 61.3578,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.117,
    y: 604.666,
    width: 61.3578,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.852,
    y: 604.666,
    width: 61.3578,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.758,
    y: 631.044,
    width: 64.225,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.625,
    y: 631.044,
    width: 64.225,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.375,
    y: 631.044,
    width: 64.225,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.117,
    y: 631.044,
    width: 64.225,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.852,
    y: 631.044,
    width: 64.225,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.609,
    y: 409.697,
    width: 41.8609,
    height: 6.88125,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.53,
    cy: 407.002,
    r: 16.343,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.758 585.169H974.661",
    stroke: "#BBC2D1",
    strokeWidth: 0.573438
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-212-inside-1_935_5629",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419 180C419 174.477 423.477 170 429 170H1143C1148.52 170 1153 174.477 1153 180V670C1153 675.523 1148.52 680 1143 680H429C423.477 680 419 675.523 419 670V180Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419 180C419 174.477 423.477 170 429 170H1143C1148.52 170 1153 174.477 1153 180V670C1153 675.523 1148.52 680 1143 680H429C423.477 680 419 675.523 419 670V180Z",
    stroke: "#221D30",
    strokeWidth: 40,
    mask: "url(#path-212-inside-1_935_5629)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227 419C233.99 388.667 269.006 328 325.656 328C382.306 328 413.198 388.667 425 419",
    stroke: "#221D30",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217,
    cy: 481,
    rx: 44,
    ry: 77,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 646H1153V686.53C1153 692.865 1147.86 698 1141.53 698H430.47C424.135 698 419 692.865 419 686.53V646Z",
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_935_5629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330 337.899C404.006 337.899 464 395.879 464 467.399C464 518.074 433.881 561.95 390 583.222V635.944C487.201 649.562 562 733.046 562 834V887C562 997.457 472.457 1087 362 1087H284C173.543 1087 84 997.457 84 887V834C84 731.321 161.376 646.715 261 635.309V578.431C222.054 555.777 196 514.53 196 467.399C196 395.879 255.994 337.899 330 337.899Z",
    fill: "url(#paint0_linear_935_5629)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427,
    cy: 481,
    rx: 44,
    ry: 77,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.656 328C382.306 328 413.198 388.667 425 419",
    stroke: "#221D30",
    strokeWidth: 20
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_935_5629",
    x: 409,
    y: 164,
    width: 753.852,
    height: 612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_935_5629"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_935_5629",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_935_5629",
    x: 74,
    y: 331.899,
    width: 498,
    height: 769.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_935_5629"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_935_5629",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_5629",
    x1: 411,
    y1: 384,
    x2: -58.5,
    y2: 1291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_5629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_935_5629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 733.852,
    height: 477.004,
    fill: "white",
    transform: "translate(419 170)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_935_5629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 734,
    height: 477.1,
    fill: "white",
    transform: "translate(419 170)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialistCaseViewer);
export default __webpack_public_path__ + "static/media/SpecialistCaseViewer.e4f18f72ca69db1a62a4d56ee079980a.svg";
export { ForwardRef as ReactComponent };